import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-purple/15" data-id="element-308">
    <div className="flex items-center mb-4" data-id="element-309">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-purple font-serif font-bold text-sm md:text-xl border border-brand-purple/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-310">
        {initials}
      </div>
      <div data-id="element-311">
        <div className="flex text-brand-gold mb-1 text-[15px] md:text-lg" data-id="element-312">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-313" />)}
        </div>
        <div className="font-medium text-brand-text md:text-lg" data-id="element-314">{name}</div>
        <div className="text-xs md:text-sm text-brand-muted" data-id="element-315">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] md:text-base font-serif leading-relaxed" data-id="element-316">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  return <Section className="pt-8 pb-16" data-id="element-317">
      <div className="max-w-3xl mx-auto" data-id="element-318">
        <TestimonialCard initials="MG" name="María G." location="Córdoba" text="Por primera vez tengo un sistema completo para planificar mis sesiones de Chi Kung con criterio clínico real. Mis pacientes sienten la diferencia desde la primera semana." data-id="element-319" />
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    product: 'Terapeuta holística',
    text: 'Por primera vez tengo un sistema para planificar mis sesiones con criterio clínico real. El Vademécum de series por patología me cambió completamente la forma de trabajar.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Chi Kung terapéutico',
    text: 'El Tomo I de blindaje del terapeuta me salvó del agotamiento crónico. Antes terminaba cada jornada destruida. Ahora tengo protocolos reales y mi energía es completamente diferente.'
  }, {
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Rosario',
    product: 'Terapeuta en formación',
    text: 'Recién empezaba y el Mega Pack me dio la estructura que necesitaba desde el primer paciente. Los 52 guiones de visualización solos valen todo el pack.'
  }, {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Tucumán',
    product: 'Terapeuta holístico',
    text: 'El Protocolo de Chi Kung Adaptado me abrió un nicho que no imaginaba. Ahora trabajo con adultos mayores y pacientes post-quirúrgicos con total seguridad clínica.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-320">
      <div className="text-center mb-12" data-id="element-321">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-purpleDark pt-[0px]" data-id="element-322">
          ❤️ LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] md:text-sm max-w-4xl mx-auto" data-id="element-323">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-324" />)}
      </div>
    </Section>;
};